import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../contexts/ThemeContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowUpRight, FiImage } = FiIcons;

const ProjectCard = ({ project, index, onClick }) => {
  const { isDark } = useTheme();

  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      whileHover={{ y: -8 }}
      onClick={onClick}
      className={`group cursor-pointer rounded-2xl overflow-hidden transition-all duration-300 ${
        isDark 
          ? 'bg-gray-800 hover:bg-gray-750 shadow-xl shadow-gray-900/20' 
          : 'bg-white hover:bg-gray-50 shadow-xl shadow-gray-900/10'
      }`}
    >
      <div className="relative overflow-hidden">
        <div className="aspect-video">
          {project.pix ? (
            <img
              src={project.pix}
              alt={project.name}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
          ) : null}
          <div className={`w-full h-full flex items-center justify-center ${project.pix ? 'hidden' : 'flex'} ${
            isDark ? 'bg-gray-700' : 'bg-gray-100'
          }`}>
            <SafeIcon 
              icon={FiImage} 
              className={`w-12 h-12 ${isDark ? 'text-gray-500' : 'text-gray-400'}`} 
            />
          </div>
        </div>
        
        <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="p-2 bg-orange-500 rounded-full">
            <SafeIcon icon={FiArrowUpRight} className="w-4 h-4 text-white" />
          </div>
        </div>
      </div>

      <div className="p-6">
        <div className="flex items-start justify-between mb-3">
          <h3 className={`text-xl font-bold line-clamp-2 ${isDark ? 'text-white' : 'text-gray-900'}`}>
            {project.name || 'Untitled Project'}
          </h3>
        </div>
        
        <p className={`text-sm mb-4 line-clamp-3 ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
          {project.desc || 'No description available'}
        </p>
        
        {project.cat && (
          <div className="flex items-center">
            <span className={`px-3 py-1 rounded-full text-xs font-medium ${
              isDark 
                ? 'bg-gray-700 text-gray-300' 
                : 'bg-gray-100 text-gray-700'
            }`}>
              {project.cat}
            </span>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default ProjectCard;